import type React from "react"
import { Card } from "@/components/ui/card"
import {
	FileText,
	Link as LinkIcon,
	Youtube,
	Users,
	Video,
	FileSpreadsheet,
	SwatchBook,
} from "lucide-react"
import { MdOutlineAppShortcut } from "react-icons/md";
import type { IMoreDocument } from "@/lib/types/course/detail"
interface MoreDocumentProps {
	moreDocument: IMoreDocument
}

const MoreDocument: React.FC<MoreDocumentProps> = ({ moreDocument }) => {
	if (!moreDocument) return null
	return (
		<Card className="mt-4">
			<div className="p-4">
				<h3 className="mb-4 font-semibold text-lg">Tài liệu bổ sung</h3>
				<div className="space-y-3">
					{moreDocument.documents && (
						<a
							href={moreDocument.documents}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 text-blue-600 hover:underline"
						>
							<FileText className="h-4 w-4" />
							<span>Tài liệu</span>
						</a>
					)}
					{moreDocument.lecture_slides && (
						<a
							href={moreDocument.lecture_slides}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 text-yellow-600 hover:underline"
						>
							<FileSpreadsheet className="h-4 w-4" />
							<span>Slide bài giảng</span>
						</a>
					)}
					{moreDocument.google_meet_room && (
						<a
							href={moreDocument.google_meet_room}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 text-green-600 hover:underline"
						>
							<Video className="h-4 w-4" />
							<span>Phòng Google Meet</span>
						</a>
					)}
					{moreDocument.template && (
						<a
							href={moreDocument.template}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 text-green-600 hover:underline"
						>
							<MdOutlineAppShortcut className="h-4 w-4" />
							<span>Tải App mẫu</span>
						</a>
					)}
					{moreDocument.database_google_sheet && (
						<a
							href={moreDocument.database_google_sheet}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 text-blue-600 hover:underline"
						>
							<LinkIcon className="h-4 w-4" />
							<span>Truy cập Database</span>
						</a>
					)}
					{moreDocument.zalo_group && (
						<a
							href={moreDocument.zalo_group}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-2 text-blue-700 hover:underline"
						>
							<Users className="h-4 w-4" />
							<span>Tham gia nhóm Zalo</span>
						</a>
					)}
				</div>
			</div>
		</Card>
	)
}

export default MoreDocument
